(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-press"] && !Shopify.designMode) return;
  try {
    
    function initAboutPress(root) {
        if (!root || root.dataset.aboutPressReady === 'true' || typeof Swiper === 'undefined') return;
        var slider = root.querySelector('.about-press__slider');
        if (!slider) return;
        root.dataset.aboutPressReady = 'true';
        new Swiper(slider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            speed: 450,
            watchOverflow: true,
            pagination: {
                el: root.querySelector('.about-press__dots'),
                clickable: true
            },
            breakpoints: {
                990: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 24
                }
            }
        });
    }

    var aboutPressTries = 0;

    function bootAboutPress() {
        if (typeof Swiper === 'undefined') {
            aboutPressTries += 1;
            if (aboutPressTries < 40) window.setTimeout(bootAboutPress, 50);
            return;
        }
        document.querySelectorAll('.about-press').forEach(initAboutPress);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootAboutPress);
    } else {
        bootAboutPress();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var root = event.target.querySelector('.about-press');
        if (root) initAboutPress(root);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.hideAtBar = this.hasAttribute('data-hide-at-bar');
      this.barLayoutTop = null;
      this.anchorBarHiding = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      this.observeAnnouncementBar();
      this.observeProductAnchorBar();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.syncAnnouncementOffset();
    }

    syncAnnouncementOffset() {
      const announcement = document.querySelector('.announcement-bar-section');
      const hidden = document.body.classList.contains('no_annbar');
      const height = !hidden && announcement && announcement.offsetParent !== null
        ? announcement.offsetHeight
        : 0;
      document.documentElement.style.setProperty('--utility-bar-height', `${height}px`);
    }

    observeAnnouncementBar() {
      const announcement = document.querySelector('.announcement-bar-section');
      this.syncAnnouncementOffset();
      if (!announcement || typeof ResizeObserver === 'undefined') return;
      this.announcementObserver = new ResizeObserver(() => this.syncAnnouncementOffset());
      this.announcementObserver.observe(announcement);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.onAnchorBarResize) {
        window.removeEventListener('resize', this.onAnchorBarResize);
        window.removeEventListener('load', this.onAnchorBarResize);
      }
      if (this.announcementObserver) this.announcementObserver.disconnect();
    }

    observeProductAnchorBar() {
      if (!this.hideAtBar) return;

      this.onAnchorBarResize = () => {
        this.barLayoutTop = null;
        this.syncProductAnchorBar();
      };
      window.addEventListener('resize', this.onAnchorBarResize);
      window.addEventListener('load', this.onAnchorBarResize);
      requestAnimationFrame(this.onAnchorBarResize);
    }

    announcementOffset() {
      const height = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--utility-bar-height')
      );
      return Number.isFinite(height) ? height : 0;
    }

    productHeaderStackHeight() {
      let height = this.header.offsetHeight;
      const floating = this.header.querySelector('.floating_refuse');
      if (floating && this.header.classList.contains('scrolled-past-header')) {
        height += floating.offsetHeight;
      }
      return height;
    }

    layoutDocumentTop(element) {
      let top = 0;
      let node = element;
      while (node) {
        top += node.offsetTop || 0;
        node = node.offsetParent;
      }
      return top;
    }

    syncProductAnchorBar(scrollTop) {
      const bar = document.querySelector('.stickey_bar_i');
      if (!bar) {
        this.releaseAnchorBarHide();
        return;
      }

      const scroll = scrollTop == null ? window.pageYOffset || document.documentElement.scrollTop : scrollTop;
      const stickLine = this.announcementOffset();
      const headerHeight = this.productHeaderStackHeight();
      const barTop = bar.getBoundingClientRect().top;
      const barIsStuck = scroll > stickLine && barTop <= stickLine + 1;

      if (!barIsStuck) {
        this.barLayoutTop = barTop + scroll;
      } else if (this.barLayoutTop == null) {
        this.barLayoutTop = this.layoutDocumentTop(bar);
      }

      const overlap = stickLine + headerHeight - (this.barLayoutTop - scroll);

      if (overlap > 0) {
        const applied = Math.min(overlap, stickLine + headerHeight);
        this.header.style.transition = 'none';
        this.header.style.top = stickLine - applied + 'px';
        this.header.classList.add('shopify-section-header-hidden');
        if (!this.anchorBarHiding) {
          this.anchorBarHiding = true;
          this.closeMenuDisclosure();
          this.closeSearchModal();
        }
      } else {
        this.releaseAnchorBarHide();
      }
    }

    syncFloatingRefuse(stickLine, scroll) {
      const floating = this.header.querySelector('.floating_refuse');
      if (!floating || this.barLayoutTop == null || !this.header.classList.contains('scrolled-past-header')) {
        this.header.classList.remove('hide-floating-refuse');
        return;
      }

      const floatingBottom = stickLine + this.header.offsetHeight + floating.offsetHeight;
      const barNaturalTop = this.barLayoutTop - scroll;
      this.header.classList.toggle('hide-floating-refuse', barNaturalTop <= floatingBottom);
    }

    releaseAnchorBarHide() {
      this.anchorBarHiding = false;
      if (!this.header) return;
      if (this.header.style.top) this.header.style.top = '';
      if (this.header.style.transition) this.header.style.transition = '';
      this.header.classList.remove('shopify-section-header-hidden', 'hide-floating-refuse');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.hideAtBar) this.syncProductAnchorBar(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          if (this.hideAtBar) this.syncFloatingRefuse(this.announcementOffset(), scrollTop);
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      if (this.hideAtBar) this.syncFloatingRefuse(this.announcementOffset(), scrollTop);
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.hideAtBar) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.hideAtBar) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.hideAtBar) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
